var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThegamer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 68 68",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linejoin:round;}.cls-1{stroke-width:4.48px;}.cls-2{stroke-width:2.69px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M465.77,1832.37l-3.45-3.45a2.69,2.69,0,0,1,0-3.8l3.43-3.43",
    transform: "translate(-459.3 -1793.68)",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M470,1817.44l3-3a2.69,2.69,0,0,1,3.8,0l10.67,10.67a2.69,2.69,0,0,1,0,3.8l-10.67,10.67a2.69,2.69,0,0,1-3.8,0l-3-3",
    transform: "translate(-459.3 -1793.68)",
    className: "cls-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M519.53,1821.67l3.45,3.45a2.69,2.69,0,0,1,0,3.8l-3.43,3.43",
    transform: "translate(-459.3 -1793.68)",
    className: "cls-1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M515.3,1836.6l-3,3a2.69,2.69,0,0,1-3.8,0l-10.67-10.67a2.69,2.69,0,0,1,0-3.8l10.67-10.67a2.69,2.69,0,0,1,3.8,0l3,3",
    transform: "translate(-459.3 -1793.68)",
    className: "cls-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M487.3,1800.15l3.45-3.45a2.69,2.69,0,0,1,3.8,0l3.43,3.43",
    transform: "translate(-459.3 -1793.68)",
    className: "cls-1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M502.23,1804.38l3,3a2.69,2.69,0,0,1,0,3.8l-10.67,10.67a2.69,2.69,0,0,1-3.8,0l-10.67-10.67a2.69,2.69,0,0,1,0-3.8l3-3",
    transform: "translate(-459.3 -1793.68)",
    className: "cls-2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M498,1853.91l-3.45,3.45a2.69,2.69,0,0,1-3.8,0l-3.43-3.43",
    transform: "translate(-459.3 -1793.68)",
    className: "cls-1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M483.07,1849.68l-3-3a2.69,2.69,0,0,1,0-3.8l10.67-10.67a2.69,2.69,0,0,1,3.8,0l10.67,10.67a2.69,2.69,0,0,1,0,3.8l-3,3",
    transform: "translate(-459.3 -1793.68)",
    className: "cls-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThegamer);
export default __webpack_public_path__ + "static/media/thegamer.9383962a14a70d6bec95ad5acb45bc0c.svg";
export { ForwardRef as ReactComponent };